import * as React from 'react'
import { createTheme, ThemeProvider } from '@mui/material/styles'

const { palette } = createTheme()

const theme = createTheme({
  palette: {
    primary: { main: '#85586f' },
    secondary: { main: '#d0b8a8' },
    tertiary: palette.augmentColor({ color: { main: '#dfd3c3' } }),
    quaternary: { main: '#f8ede3' },
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          transition: 'all 0.2s ease',
          color: 'black',
          '&.Mui-selected': {
            backgroundColor: '#d0b8a8',
          },
          backgroundColor: '#fafafa',
        },
      },
    },
  },
})

export default function Palette({ children }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
